import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
// Models
import mDeviceSlave from 'models/deviceSlave';
// Custom
import {
  getDeviceSlavesList, deleteDeviceSlave, getCompanies, refreshList,
} from 'actions';
import { fullListShape, deleteShape } from 'constants/PropTypesShapes';
import { navigateToShow } from 'deviceSlaves/navigation';
import { computeErrors } from 'utils/Forms';
import MainListTemplate from 'components/templates/MainListTemplate';
import withPermissions from 'hocs/WithPermissions';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withLoading from 'hocs/WithLoading';
import withStateReinit from 'hocs/WithStateReinit';
import withTitle from 'hocs/WithTitle';
import DeviceSlaveFilters from 'deviceSlaves/assets/main/DeviceSlaveFilters';
import DeviceSlaveRow from 'deviceSlaves/assets/main/DeviceSlaveRow';

class DeviceSlavesList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteDeviceSlave = this.handleDeleteDeviceSlave.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidMount() {
    const { hasPermission, handleGetCompanies } = this.props;

    if (hasPermission({ needed: permissions.pAdmin })) {
      handleGetCompanies();
    }
  }

  componentDidUpdate(prevProps) {
    const { deviceSlaveDelete, handleRefreshList } = this.props;
    // Operations catching
    if (!prevProps.deviceSlaveDelete.deleted && deviceSlaveDelete.deleted) {
      handleRefreshList();
    }
  }

  // Handlers
  handleDeleteDeviceSlave(deviceSlave) {
    const { handleDisplayConfirm, handleDeleteDeviceSlave } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteDeviceSlave', values: { deviceSlaveSerial: deviceSlave.serial } },
      () => handleDeleteDeviceSlave(deviceSlave.id),
    );
  }

  handleRowDbleClick(deviceSlave) {
    const { handleStartLoading } = this.props;
    if (deviceSlave) {
      // Display loader and display device slave
      handleStartLoading();
      _delay(() => navigateToShow(deviceSlave.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <DeviceSlaveRow
        {...props}
        onDelete={this.handleDeleteDeviceSlave}
      />
    );
  }

  render() {
    const { deviceSlaves, deviceSlaveDelete, handleGetDeviceSlavesList } = this.props;

    // Compute errors
    const errors = computeErrors(null, deviceSlaveDelete.error);

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.deviceSlavesList" />
        }
        icon={mDeviceSlave.icon}
        displayRefresh
        name={mDeviceSlave.name}
        listFeatures={mDeviceSlave.listFeatures}
        errors={errors}
        withActions
        nbActions={2}
        elementsData={{
          loading: deviceSlaves.loading,
          elements: deviceSlaves.elements,
          handleGetList: handleGetDeviceSlavesList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={
          <DeviceSlaveFilters />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

DeviceSlavesList.propTypes = {
  deviceSlaves: fullListShape.isRequired,
  deviceSlaveDelete: deleteShape.isRequired,
  handleRefreshList: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetDeviceSlavesList: PropTypes.func.isRequired,
  handleDeleteDeviceSlave: PropTypes.func.isRequired,
  handleGetCompanies: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  deviceSlaves: state.deviceSlave.list,
  deviceSlaveDelete: state.deviceSlave.delete,
});

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleGetDeviceSlavesList: (pagination, sort, filters) => {
    dispatch(getDeviceSlavesList(pagination, sort, filters));
  },
  handleDeleteDeviceSlave: (id) => {
    dispatch(deleteDeviceSlave(id));
  },
  handleGetCompanies: () => {
    dispatch(getCompanies());
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withPermissions,
  withConfirmDialog,
  withLoading,
  withStateReinit(['deleteDeviceSlave']),
  withTitle('pageTitle.deviceSlaves'),
)(DeviceSlavesList);



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/routes/list/components/DeviceSlavesList.js